import IndexVM from './index-vm';
export default {
  init: function(){
    console.log('Initializing Kadenze.InstructorResourceIndex');

    //Following options explained here: https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    var data = JSON.parse($('#resources_json').val());
    ko.applyBindingsWithValidation(new IndexVM(data), document.getElementById('resource_index'), validationOptions);
  }
};

